import { Component, h, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'signet-breadcrumb',
  styleUrl: 'signet-breadcrumb.scss',
  shadow: true,
})
export class SignetBreadcrumb {
  @Prop() items: string[] | string;
  /**
   * Represent an array of strings which will be displayed on the breadcrumb
   */

  private _items: string[];
  /**
   * The items prop is a string or an array of strings that represent the breadcrumb items.
   * If it's a string, it will be parsed as JSON. 
   * If it's an array, it will be used as is.
   * @example ["Home", "Products", "Electronics"]
   * @type {string[] | string}
   * @required
   * @description The items prop is a string or an array of strings that represent the breadcrumb items.
   * If it's a string, it will be parsed as JSON.
   * If it's an array, it will be used as is.
   * @default []
   */
  @Watch('items')
  parseItemsProp(newValue: string[] | string) {
    if (typeof newValue === 'string') {
      this._items = JSON.parse(newValue);
    } else {
      this._items = newValue;
    }
  }

  componentWillLoad() {
    this.parseItemsProp(this.items);
  }

  render() {
    return (
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          {this._items.map((item, index) => (
            <li
              class={`breadcrumb-item ${
                index === this.items.length - 1 ? 'active' : ''
              }`}
              aria-current={
                index === this.items.length - 1 ? 'page' : undefined
              }
            >
              {item}
            </li>
          ))}
        </ol>
      </nav>
    );
  }
}
